const STORAGE_KEY = 'corner:chatFont';

export type ChatFont = 'geist' | 'inter' | 'system' | 'times' | 'georgia' | 'mono' | 'lexend';

export const CHAT_FONT_OPTIONS: Array<{ key: ChatFont; label: string; preview: string }> = [
  { key: 'geist', label: 'Geist', preview: "'Geist', 'Geist Variable', ui-sans-serif, system-ui, sans-serif" },
  { key: 'inter', label: 'Inter', preview: "'Inter', ui-sans-serif, system-ui, sans-serif" },
  { key: 'system', label: 'System', preview: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, system-ui, sans-serif" },
  { key: 'times', label: 'Times New Roman', preview: "'Times New Roman', Times, serif" },
  { key: 'georgia', label: 'Georgia', preview: "Georgia, 'Times New Roman', serif" },
  { key: 'mono', label: 'Monospace', preview: "'SF Mono', 'Fira Code', 'Cascadia Code', Menlo, monospace" },
  { key: 'lexend', label: 'Lexend', preview: "'Lexend', ui-sans-serif, sans-serif" },
];

const FONT_STACKS: Record<ChatFont, string> = Object.fromEntries(
  CHAT_FONT_OPTIONS.map((o) => [o.key, o.preview])
) as Record<ChatFont, string>;

const VALID_KEYS = new Set<string>(CHAT_FONT_OPTIONS.map((o) => o.key));

export function getChatFont(): ChatFont {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && VALID_KEYS.has(v)) return v as ChatFont;
  } catch {}
  return 'geist';
}

export function setChatFont(value: ChatFont): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {}
  applyChatFont();
}

export function applyChatFont(): void {
  if (typeof document === 'undefined') return;
  const font = getChatFont();
  const stack = FONT_STACKS[font];
  document.documentElement.style.setProperty('--chat-font-family', stack);
}
